import React from 'react';
import PropTypes from 'prop-types';
import { ReportTableContentStyle } from './ReportTableContentStyle';

const ReportTableContent = ({
  contentName,
  noBorderBottomRadius,
  rows,
  title,
  onEvaluationsClick,
}) => {
  return (
    <ReportTableContentStyle>
      {title && title.length ? (
        <h3 className="table-title">{title}</h3>
      ) : null}
      <div className="table-content">
        {contentName && contentName.length ? (
          <h4 className="table-content-name">{contentName}</h4>
        ) : null}
        <div
          className={`table-content-rows${
            noBorderBottomRadius ? ' no-border-bottom-radius' : ''
          }`}
        >
          {rows && rows.length
            ? rows.map((row) =>
                row && row.label && row.value ? (
                  row.isEvaluationInfo ? (
                    <div 
                      key={row.id} 
                      className="content-row" 
                      style={{ cursor: 'pointer' }}
                      onClick={onEvaluationsClick}
                    >
                      {row.label.length ? (
                        <p className="content-row-label">{row.label}</p>
                      ) : null}
                      {row.value.length ? (
                        <p className="content-row-value" style={{ color: '#1976d2', textDecoration: 'underline' }}>
                          {row.value}
                        </p>
                      ) : null}
                    </div>
                  ) : (
                    <div key={row.id} className="content-row">
                      {row.label.length ? (
                        <p className="content-row-label">{row.label}</p>
                      ) : null}
                      {row.value.length ? (
                        <p className="content-row-value">{row.value}</p>
                      ) : null}
                    </div>
                  )
                ) : null
              )
            : null}
        </div>
      </div>
    </ReportTableContentStyle>
  );
};

ReportTableContent.propTypes = {
  contentName: PropTypes.string,
  noBorderBottomRadius: PropTypes.bool,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      isEvaluationInfo: PropTypes.bool,
    })
  ).isRequired,
  title: PropTypes.string,
  onEvaluationsClick: PropTypes.func,
};

ReportTableContent.defaultProps = {
  contentName: '',
  noBorderBottomRadius: false,
  title: '',
  onEvaluationsClick: null,
};

export default ReportTableContent;
